class FourOFourController {}

export default FourOFourController;



// WEBPACK FOOTER //
// ./client/app/oauth/four-o-four/four-o-four.controller.js